<app-info-estado-situacion *ngIf="nextComponent" title="{{title}}" (nextComponent)="cambiarFormulario($event)"></app-info-estado-situacion>
<app-formulario  *ngIf="nextForm" title="{{title}}"></app-formulario>
